import { ButtonVariants } from '../../../../Atoms/Button';
import { startFilingLinkViewPlans } from '../../../static/data';
import { ButtonWithAnchor } from '../sticky-button';
import { ApiPlan } from './types';
import { PlanCard } from './view-new-plan-modal';

export const ViewNewPlanModalContent = ({
  trackLabel,
  plansList,
}: {
  trackLabel: string;
  plansList: ApiPlan[];
  buttonLink: string;
}): JSX.Element => {
  const sortedPlans = [...plansList].sort((a, b) => a.index - b.index);

  return (
    <div className="flex flex-col w-full  rounded-[16px] bg-white p-6 md:p-4">
      {/* Header */}
      <div className="mb-5">
        <p className="text-s-24 sm:text-s-20  text-font-500 mb-1">
          Self Filing (DIY) Plans
        </p>
        <p className="text-s-14 text-grey-700 font-normal">
          Don‘t worry, the plan will be selected automatically basis your income
          type and bracket.
        </p>
        <hr className="w-full mt-8"></hr>
      </div>

      <div className="flex flex-row gap-4  pb-4 sm:block">
        {sortedPlans.map((plan) => (
          <PlanCard key={plan.id} plan={plan} />
        ))}
      </div>
      <hr className="py-2"></hr>
      <div className="flex items-center justify-end  position-absolute px-4 ">
        <ButtonWithAnchor
          trackLabel={trackLabel}
          buttonText="Start Filing"
          buttonVariant={ButtonVariants.bluefilled}
          className="px-24 py-3 text-base"
          buttonLink={startFilingLinkViewPlans}
        />
      </div>
    </div>
  );
};
